//使用格式说明：
//1、带参数：已更新{parm}讲，参数位置可以调整，ag:Updated Lecture {parm}
const cn = {
    public: {
        moneyUnit:'币',
        nodata: '暂无相关数据~',
        share:"分享",
        orderNumber:"订单号",
        remark:"备注",
        save:"保存",
        vcode:"请输入验证码",
        getCode:"获得验证码",
        inputPhone:"请输入手机号",
        detail:"详情",
        hour:"小时",
        minute:"分钟",
        second:"秒",
        again:'重新获取{parm}秒',
        sex_1:"男",
        sex_2:"女",
        sex_3:"保密",
        payTitle:'请输入支付密码',
        payMethod:'支付方式',
        paySmall :'零钱',
        cancel :'取消',
        send:'已发送到',
        verifyId:'身份验证',
        loginRegister:'注册账号',
        selectArea:'请选择国际电话区号',
        contactus:'联系客服',
        pageViews:"{parm}浏览",
        pageViews_1:"浏览量{parm}",
        rebate:"{parm}折起",
        ok:'确定',
        get:'{parm} 获得 {parm_1}',
        close:'关闭',
        service:'客服'

    },
    pull:{
        loading:'加载中...',
        swipe:'下拉刷新',
        release:'释放更新'
    },
    tabbar:{
        home:'首页',
        assort:'商城',
        points:'仓库',
        mine:'我的'
    },
    pay:{
        key_1:"余额支付",
        key_2:"余额"
    },
    index: {
        key_1:'最高优惠$',
        key_2:'限时优惠{parm}%oFF',
        key_4:'我知道了',
        key_6:'券后',
        key_7:'部分盒子可用',
        key_8:'全部盒子可用',
        key_9:'满${parm}可用',
        key_10:'满${parm} 部分盒子可用',
        key_11:'满${parm} 全部盒子可用',
        key_12:'立即领取',
        key_13:'去使用',
        key_14:'全部领取',
        key_15:'明天再来',
        key_16:'立即参与',
        key_17:'选择优惠券',
        key_18:'无门槛',
        key_20:'有效期至{parm}',
        key_21:'确定订单',
        key_22:'{parm}张可用',
        key_23:'优惠券',
        key_24:'连抽优惠',
        key_25:'共计优惠:',
        key_26:'立即支付',
        key_27:'用户服务协议及隐私政策',
        key_28:'支付提醒',
        key_29:'支付成功费用将从零钱中减除，继续请点确定支付',
        key_30:'确定支付',
        key_31:'立即开盒',
        key_39:'支付成功将扣除积分，继续请点击确定支付.',
        key_40:'积分兑换：',
        key_41:'积分支付',
        key_42:'可用积分:',
        key_43:'兑换积分'
    },
    boxdetail:{
        key_1:'100%必中价值',
        key_2:'真实概率/必中无空包/三件包邮/正品保障',
        key_3:'点击查看全部',
        key_4:'谢绝未成年人使用或在监护人的监督指导下体验',
        key_5:'分享有奖',
        key_6:'商品详情',
        key_7:'开盒必出以下宝贝之一',
        key_8:'共{parm}款({parm_1}个{parm_2})'/* 共10款(10个传说/史诗) */
    },
    box:{
        key_1:'去仓库',
        key_2:'再来一发',
        key_3:'可兑换:',
        key_4:'币',
        key_5:'提示:请在<i>{parm}</i>前提货,过期将不再提货，只能兑换',
        key_6:'兑换',
        key_7:'提货',
        key_8:'商品',
        key_9:'盲盒',
        key_10:'去开盒',
        key_11:'<p>兑换需知</p><p>1.获得商品可以兑换成币服务</p><p>2.兑换成功的币可用于商城产品兑换</p><p>3.币兑换成功不可逆转，不可转让，不可提现</p><p>4.币最终解析权归平台所有，有疑问请联系客服</p>',
        key_12:'共{parm}件',
        key_13:'合计:',
        key_14:'立即兑换',
        key_15:'兑换提醒',
        key_16:'兑换币后不可逆转，请确定是否兑换？',
        key_18:'兑换成功',
        key_19:'获得{parm}币',
        key_20:'返去仓库',
        key_21:'去调选商品',
        key_22:'确定订单',
        key_23:'请添加收件地址',
        key_24:'配送方式',
        key_25:'免运费',
        key_26:'优惠券',
        key_27:'没有优惠券',
        key_28:'订单备注',
        key_29:'可给商家留言',
        key_30:'提交订单',
        key_31:'仓库没有适合的商品！',
        key_32:'提货提醒',
        key_33:'提货后会生成待发货订单，可在订单中心查看，继续请点击确定？',
        key_34:'成功创建提货订单！',
        key_35:'选择要提货的商品',
        key_36:'全选',
        key_37:'已选择<i>{parm}</i>件',
        key_38:'立即提货',
  
    },
    mall:{
        key_1:'我的货币',
        key_2:'全部',
        key_3:'{parm}以上',
        key_4:'客服',
        key_5:'直接购买',
        key_6:'立即兑换',
        key_7:'库存:',
        key_8:'购买数量',
        key_9:'(每人限购{parm}件)',
        key_10:'立即购买',
        key_11:'请选择好规格',
        key_12:'确定订单',
        key_13:'请添加收件地址',
        key_14:'配送方式',
        key_15:'免运费',
        key_16:'优惠券',
        key_17:'没有优惠券',
        key_18:'订单备注',
        key_19:'可给商家留言',
        key_20:'共{parm}件',
        key_21:'合计:',
        key_22:'支付订单',
        key_23:'支付成功将从积分中扣除',
        key_24:'支付成功将从零钱中扣除费用',
        key_25:'继续请点击确定？',
        key_26:'支付成功！',
        key_27:'我的订单',
        key_28:'订单号:',
        key_29:'删除订单',
        key_30:'订单详情',
        key_31:'全部',
        key_32:'待付款',
        key_33:'待发货',
        key_34:'待收货',
        key_35:'已完成',
        key_36:'删除提醒',
        key_37:'确定删除订单，继续请点击确定？',
        key_38:'付款方式',
        key_39:'兑换币',
        key_40:'订单编号',
        key_41:'下单时间',
        key_42:'付款时间',
        key_43:'发货时间',
        key_44:'完成时间',
        key_45:'买家留言',
        key_46:'确认收货',
        key_47:'收货提醒',
        key_48:'在确保真实收到货后再点击收货，继续请点击确定？',
        key_49:'已确定收货！',
        key_50:'已删除',
        key_51:'综合',
        key_52:'价格',
        key_53:'币',
    },
    coupon:{
        key_1:"优惠券",
        key_2:"无门槛",
        key_3:'满${parm}可用',
        key_4:"有效期至 {parm}",
        key_5:"去使用",
        key_6:"未使用",
        key_7:"已使用",
        key_8:"已过期",
    },
    address:{
        key_1:"地址管理",
        key_2:"设为默认",
        key_3:"编辑",
        key_4:"删除",
        key_5:"添加地址",
        key_6:"操作提示",
        key_7:"删除地址不可逆转操作，继续请点击确定？",
        key_8:"编辑地址",
        key_9:"收件人：",
        key_10:"请输入联系姓名",
        key_11:"手机号：",
        key_12:"请输入联系手机",
        key_13:"所在地区：",
        key_14:"详细地址：",
        key_15:"默认地址："

    },
    about:{
        key_1:"关于",
        key_2:"当前版本",
        key_3:"版本更新",
        key_4:"当前已是最新版本"
    },
    account:{
        key_1:"我的账户",
        key_2:"转账",
        key_3:"账户余额",
        key_4:"充值",
        key_5:"资金记录",
        key_6:"提现",
        key_7:"提现记录",
        key_9:"收益记录",
        key_10:"我的收益",
        key_11:"今日收益",
        key_12:"本月收益",
        key_13:"上月收益",
        key_14:'上拉获得更多记录'
    },
    bindphone:{
        key_1:"绑定手机",
        key_2:"原手机号",
        key_3:"新手机号",
        key_4:"更换",
        key_5:"当前手机号",
        key_6:"更换手机号不会影响账户VIP期限、余额和已购产品",
        key_7:"输入新的手机号",
        key_8:"更换手机号",
        key_9:"用户已存在",
        key_10:"请更换其他手机号或联系客服更改",
        key_11:"输入验证码完成绑定"
    },
    cPassword:{
        key_1:"修改密码",
        key_2:"旧密码",
        key_3:"请输入旧密码",
        key_4:"新密码",
        key_5:"确定密码",
        key_6:"请输入新密码",
        key_7:'密码为8~20位，需包含数字与字母',
        key_8:"请输入密码",
        key_9:'请再次输入密码',
    },
    editname:{
        key_1:"修改名称",
        key_2:"请输入名称",
        key_3:"推荐使用中文，4-10个字符",
    },
    help:{
        key_1:"帮助中心"
    },
    incomedetail:{
        key_1:"资金明细",
        key_2:"入账金额",
        key_3:"出账金额",
        key_4:"类型",
        key_5:"收入",
        key_6:"支出",
        key_7:"时间",
        key_8:"交易单号",
        key_9:"余额",
        key_10:"备注"
    },
    invite:{
        key_1:"邀请记录",
        key_2:"邀请好友",
        key_3:"点击复制邀请码链接",
        key_4:"复制成功！"
    },
    login:{
        key_1:"注册账号",
        key_2:"密码登录",
        key_3:"请输入密码",
        key_4:"忘记密码",
        key_5:"登录即表示您已同意",
        key_6:"用户服务协议及隐私政策",
        key_7:"登录",
        key_8:"请输入登录账号",
        key_9:"请输入登录密码",
        key_10:"登录中...",
        key_11:"邀请码",
        key_12:"已有账号?立即登录",
        key_13:"确定",
        key_14:"注册中...",
        key_15:"处理中...",
        key_16:"修改密码",
    },
    mine:{
        key_1:"登录/注册账户",
        key_2:"编辑资料",
        key_3:"我的零钱",
        key_4:"我的币",
        key_5:"商品",
        key_6:"盲盒",
        key_7:"我的应用",
        key_8:"优惠券",
        key_9:"地址管理",
        key_10:"帮助中心",
        key_11:"邀请有奖",
        key_12:"签到领盲盒",
        key_13:"我的订单",
        key_14:"全部订单",
        key_15:"待付款",
        key_16:"待发货",
        key_17:"待收货",
        key_18:"已完成",

    },
    notice:{
        key_1:"消息中心",
        key_2:"通知列表",
        key_3:"全部已读",
        key_4:"点此查看"
    },
    recharge:{
        key_1:"充值",
        key_2:"注意：线下转账按照下面提供的收款账号，转账成功请拍下凭证并输入凭证上的金额即可。",
        key_3:"转账金额",
        key_4:"请填写与凭证一样的金额。",
        key_5:"确定提交",
        key_6:"如有问题请联系客服",
        key_7:"请打凭证上传",
        key_8:"打款凭证",
        key_9:"请打款至",
        key_10:"开户银行",
        key_11:"持卡人姓名",
        key_12:"银行账号",
        key_13:"切换银行",
        key_14:"当前选择的银行",
        key_15:"选择银行",
        key_16:"请输入充值金额",
        key_17:"请上传充值凭证",
        key_18:"确认以上账户名是和身份证一致么？",
        key_19:"是的",
        key_20:"去实名认证"
    },
   
   
    setPaypaswd:{
        key_1:"设置支付密码",
        key_2:"支付密码",
        key_3:"请输入新密码",
        key_4:"手机号码",
        key_5:"支付密码提示",
        key_6:"点击按钮'立即设置'或到'我的'-->'个人信息'-->'支付密码'设置支付密码。",
        key_7:"立即设置",
        key_8:"取消",
        key_9:"设置支付密码，用于支付验证",
    },

    setting:{
        key_1:"个人信息",
        key_2:"个人头像",
        key_3:"姓名",
        key_4:"性别",
        key_5:"修改密码",
        key_6:"修改",
        key_7:"绑定手机",
        key_8:"已绑定",
        key_9:"未绑定",
        key_10:"支付密码",
        key_11:"已设置",
        key_12:"未设置",
        key_13:"退出登录",
        key_14:"性别设置",
        key_15:"设置",
        key_16:"关于我们",
        key_17:"语言设置",
        key_18:"账户与安全",
        key_19:"退出提示",
        key_20:"您在正尝试退出登录，继续请点击确定？",

    },
    security:{
        key_1:"账户安全提示",
        key_2:"感谢你的使用，为了你账户安全，请先设置登录密码。",
        key_3:"前往设置",
        key_4:"下次再说"
    },
    transfer:{
        key_1:"转账",
        key_2:"注意：汇款成功后不可退还，汇款前请确定好信息的准确性。",
        key_3:"对方账号",
        key_4:"备注信息",
        key_5:"转账金额",
        key_6:"余额",
        key_7:"全部转账",
        key_8:"确定转账",
        key_9:"如有问题请联系客服",
        key_10:"请输账号和金额！"
    },
    withdraw:{
        key_1:"零钱提现",
        key_2:"提现金额",
        key_3:"账户余额",
        key_4:"全部提现",
        key_5:"提交申请",
        key_6:"银行名称",
        key_7:"银行卡号",
        key_8:"持卡人姓名",
        key_9:"收款人信息",
        key_10:"到账银行卡",
        key_11:"24小时内审核",
        key_12:"请先绑定银行卡",
    },

    integral:{
        title:"积分商城",
        key_1:"全部分类",
        key_2:"已售{parm}件",
        key_3:"剩余{parm}件",
        key_4:"浏览人数",
        key_5:"产品详情",
        key_6:"立即兑换",
        key_7:"成长福利",
        key_8:"细则",
        key_9:"我的积分",
        key_10:"我的VIP",
        key_11:"积分",
        key_12:"去完成",
        key_13:"领取",
        key_14:"明天再来",
        key_15:" 恭喜你，获得",
        key_16:" 兑换订单",
        key_17:" 待发货",
        key_18:" 已发货",
        key_19:" 订单号",
        key_20:" 总计",
        key_21:" 订单详情",
        key_22:" 订单编号",
        key_23:" 下单时间",
        key_24:" 兑换时间",
        key_25:" 共{parm}件",
        key_26:" 兑换积分",
        key_27:" 兑换结算",
        key_28:" 支付方式",
        key_29:" 积分支付",
        key_30:" 合计",
        key_31:" 确定兑换",
        key_32:" 兑换提示",
        key_33:" 兑换成功后将扣除积分，确定请点击继续。",
        key_34:" 继续",
        key_35:" 积分详情",
        key_36:" 可用积分",
        key_37:" 获取积分",
        key_38:" 积分记录",
        key_39:" 已连续签到<i>{parm}</i>天",
        key_40:" 我要签到啦",
        key_41:" 最新产品",
        key_42:" 进入店铺",


    },
    transferpoints:{
        title:"余额转积分",
        key_1:" 转换额度",
        key_2:" 全部转换",
        key_3:" 确定转换",
        key_4:" 请输入转换额度",
        key_5:" 转换提示",
        key_6:" 余额转换零钱，转换成功不可逆转，继续点击确定",
        key_7:" 注意：当前兑换比例为<i class='ratio'>1:{parm}</i> ,余额转积分转换成功不可逆转。"
        
    }
  

    

    

}
 
export default cn


// WEBPACK FOOTER //
// ./src/lang/pack/cn.js